<template>
  <div>
    <vs-input
        v-validate="'required|email|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email*"
        v-model="email"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
        data-vv-validate-on="blur"
        v-validate="'required|min:6|max:30'"
        type="password"
        name="contrasenia"
        data-vv-as="contraseña"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Contraseña*"
        v-model="contrasenia"
        class="w-full mt-6"
        @keyup.enter="loginJWT"
         />
    <span class="text-danger text-sm">{{ errors.first('contrasenia') }}</span>
    <div class="flex flex-wrap justify-between my-5">
      <span style="color:#8a8a8a; font-weight:bold;">Nota: Los campos con asterisco (<span style="color:#EA5455">*</span>) son obligatorios.</span>        
    </div>
    <div class="flex flex-wrap justify-between my-5">
        <vs-row vs-justify="flex-end">
          <router-link to="/account/forgot" style="    color: rgba(var(--vs-primary), 1) !important;">Olvidó la contraseña?</router-link>
        </vs-row>
    </div>
    <div class="flex flex-wrap justify-right mb-3" style="float:right">
      <!--vs-button  type="border" @click="registerUser">Registrarte</vs-button-->
      <vs-button :disabled="!validateForm" @click="loginJWT()">Iniciar Sesión</vs-button>
    </div>
    <vs-popup class="holamundo" title="Mapgrafi informa" :active.sync="popupMensaje">
        <p>{{ mensaje }}
            <br>
        </p>
        <div class="flex flex-wrap text-center mb-3">
            <vs-button  color="primary"  @click="(popupMensaje = !popupMensaje)">Aceptar</vs-button>
        </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popupMensaje:false,
      mensaje:'',
      email: '',
      contrasenia: '',
      checkbox_remember_me: false
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != '' && this.contrasenia != '';
    },
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    loginJWT() {

      // Loading
      this.$vs.loading()

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.contrasenia
        }
      }
      this.$store.dispatch('auth/loginJWT', payload)
        .then((response) => { 
          this.$vs.loading.close();
          if(response != null && response != []){
            this.$store.dispatch('eCommerce/agregarCarrito', response)
            .then(()=>{
                // location.reload();
                this.$router.push('/').catch(() => {})
            })
            .catch(error => {
              this.$vs.loading.close()
              this.popupMensaje = true;
              this.mensaje = error.message;
            })
          }
          else {
            // location.reload();
            this.$router.push('/').catch(() => {})
          }
        })
        .catch(error => {
          this.$vs.loading.close()
          this.popupMensaje = true;
          this.mensaje = error.message;
        })
    },
    registerUser() {
      if (!this.checkLogin()) return
      this.$router.push('/account/register').catch(() => {})
    }
  },
  created(){
    if(this.$store.state.AppActiveUser.status)
      this.$router.push('/');
}
}

</script>

